import authSelector from 'modules/Auth/selectors'
import driveSelector from 'modules/Drives/selectors'
import ViewRole from 'modules/Roles/ViewRole'
import rolesSelectors from 'modules/Roles/selectors'
import { connect } from 'react-redux'

import {
  getDriveListData,
  getDriveRoleMetrics as getRolesMetrics,
} from 'modules/Drives/actions'
import { recreateCall } from 'modules/Drives/actions'
import {
  addRoleToExistingDrive,
  closeApplication,
  createDrive,
  deleteRole,
  duplicateRole,
  getAppliedCandidateList,
  getAppliedCollegesList,
  getCandidateDetails,
  getCities,
  getDegreesBasedOnRoles,
  getDriveCreatedCandidates,
  getDriveCreatedCandidatesPreview,
  getDriveNotCreatedCandidates,
  getDriveRoleMetrics,
  getInstitutesList,
  getUniqueStudentInstitutesList,
  getListOfDegree,
  getRoleAppliedDriveMetrics,
  getStudentQuestionaireList,
  getRoleViewCard,
  getRoleViewChart,
  getSingleRoleData,
  jobSharingEmail,
  setInstitutesList,
  getRoleDataToExport,
  getRoleCityData,
  getRoleDraftData,
  getPromotion,
  getDegreeBasedOnATS,
} from 'modules/Roles/actions'

import {
  getNotificationCatalogues,
  getUserCorpList,
  sendNotificationBulkEmail,
} from 'modules/Users/actions'

import {
  getQuestionaireGraphList,
  getQuestionAndAnswerList,
} from '../../ViewRole/Header/QuestionaireDashboard/actions'
import { resumeBulkDownloadJobRoles as resumeBulkDownload } from '../../../Drives/actions'

const mapStateToProps = state => ({
  appliedCollegesList: rolesSelectors.getAppliedCollegesList(state),
  appliedCandidatesList: rolesSelectors.getAppliedCandidatesList(state),
  institutesList: rolesSelectors.getInstitutesList(state),
  listOfDegree: rolesSelectors.getListOfDegree(state),
  singleRoleData: rolesSelectors.getSingleRoleData(state),
  listOfCities: rolesSelectors.getListOfCities(state),
  driveRoleMetrics: rolesSelectors.getDriveRoleMetrics(state),
  candidateDetails: rolesSelectors.getCandidateDetails(state),
  promotionData: rolesSelectors.getPromotion(state),
  roleAppliedDriveMetrics: rolesSelectors.getRoleAppliedDriveMetrics(state),
  questionaireDBList: rolesSelectors.getStudentQuestionaireList(state),
  roleBasedDegreeList: rolesSelectors?.getDegreeRolesList(state),
  corporateId: authSelector.getCorporateId(state),
  driveData: driveSelector.getDriveData(state),
  driveRolesMetrics: driveSelector.getDriveRoleMetrics(state),
  DriveNotCreatedCandidates: rolesSelectors.getDriveNotCreatedCandidates(state),
  DriveCreatedCandidates: rolesSelectors.getDriveCreatedCandidates(state),
  roleViewCardData: rolesSelectors.getRoleViewCard(state),
  roleViewChartData: rolesSelectors.getRoleViewChart(state),
  DriveCreatedCandidatesPreview:
    rolesSelectors.getDriveCreatedCandidatesPreview(state),
  roleDataToExcel: rolesSelectors.getSingleRoleDataToExcel(state),
  permissions: authSelector.getUserPermissions(state),
  cityRoleData: rolesSelectors.getCityRoleData(state),
  draftData: rolesSelectors.getRoleDraftData(state),
  graphList: rolesSelectors.graphListData(state),
  atsBasedDegreeList: rolesSelectors?.getDegreeATSList(state),
})

const mapDispatchToProps = {
  getAppliedCollegesList,
  getAppliedCandidateList,
  getInstitutesList,
  getUniqueStudentInstitutesList,
  getListOfDegree,
  setInstitutesList,
  closeApplication,
  duplicateRole,
  deleteRole,
  getSingleRoleData,
  getCities,
  createDrive,
  getDriveRoleMetrics,
  getCandidateDetails,
  getPromotion,
  addRoleToExistingDrive,
  getRoleAppliedDriveMetrics,
  getStudentQuestionaireList,
  jobSharingEmail,
  getRolesMetrics,
  getDriveListData,
  getDegreesBasedOnRoles,
  getDriveCreatedCandidates,
  getDriveNotCreatedCandidates,
  getDriveCreatedCandidatesPreview,
  getRoleViewChart,
  getRoleViewCard,
  getNotificationCatalogues,
  sendNotificationBulkEmail,
  getUserCorpList,
  getRoleDataToExport,
  getRoleCityData,
  getRoleDraftData,
  getDegreeBasedOnATS,
  getQuestionaireGraphList,
  getQuestionAndAnswerList,
  recreateCall,
  resumeBulkDownload
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewRole)
